<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(generar)">
        <b-row>
          <b-col class="subtitulos ml-2">
            GENERACION ARCHIVO DE RENOVACION MANUAL
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-row>
              <b-col cols="4">
                <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
                  <label>Fecha de inicio:<validacion/></label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-datepicker placeholder="Fecha inicio"
                                       :max="new Date()"
                                       @input="fechaMaxima($event)"
                    ></b-form-datepicker>
                  </b-input-group>
                  <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                </validation-provider>
              </b-col>

              <b-col cols="4">
                <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
                  <label>Fecha de fin:<validacion/></label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-datepicker placeholder="Fecha fin"
                                       v-model="filtro.fechaFin"
                                       :max="filtro.fechaInicio.addDays(diasMaximoMes) > new Date() ? new Date(): filtro.fechaInicio.addDays(diasMaximoMes)"
                                       :min="filtro.fechaInicio"
                    ></b-form-datepicker>
                  </b-input-group>
                  <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                </validation-provider>
              </b-col>
              <b-col class="text-right col-2 mt-4">
                <b-button
                    variant="outline-primary"
                    size="sm"
                    :disabled="loader"
                    @click="obtenerDatos()"
                >
                  <span v-if="!loader">Buscar</span>
                  <span v-else>
                  <b-spinner small></b-spinner>
                  Buscando...
                </span>
                </b-button>
                <ArrayToTxt :lst="datos"
                            :idsMultivaArchivoSFTP="idsReferenciaMultiva"
                            @_actualizarBandeja="obtenerDatos"></ArrayToTxt>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <b-col cols="12">
      <download-excel
          v-if="datosTabla.length > 0 && $localStorageService.can('Rep_renov_portal_comer_excel')"
          class="btn btn-primary"
          :data="datosTabla"
          :fields="fieldsExcel"
          worksheet="GestionVentas"
          name="Reporte de renovacion automatica.xls"
      >
        Generar Excel
        <em class="fa fa-file-excel-o"></em>
      </download-excel>
    </b-col>
    <b-row>
      <b-col cols="12">
        <b-table
            thead-tr-class="columnas"
            :items="datosTabla"
            :fields="fields"
            :per-page="$registrosPorPaginaTabla"
            :current-page="paginaActual"
            responsive
            class="parrafos"
        >
          <template v-slot:cell(montoPagado)="row">
            ${{ row.item.montoPagado}}
          </template>
          <template v-slot:cell(montoMenosComisiones)="row">
            {{ row.item.montoMenosComisiones | monedaEntero }}
          </template>
          <template v-slot:cell(montoMenosIVA)="row">
            $ {{ row.item.montoMenosIVA | numeroDosDecimales }}
          </template>
        </b-table>
        <div align="center" v-if="loader">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <b-col v-if="!loader">
          <b-alert v-if="datosTabla!==undefined && datosTabla.length === 0" variant="warning" show>No hay datos
          </b-alert>
        </b-col>
        <b-col v-if="!loader">
          <b-pagination
              v-if="datosTabla !== undefined && datosTabla.length > 10"
              align="center"
              v-model="paginaActual"
              :total-rows="datosTabla.length"
              :per-page="$registrosPorPaginaTabla"
              aria-controls="tabla"
          ></b-pagination>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import ArrayToTxt from "@/views/ArrayToTxt";
export default {
  name: "generacionArchivoRenovacion",
  components: {
    ArrayToTxt
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datos: [],
      datosTabla: [],
      fields: [],
      registrosPorPagina: 10,
      paginaActual: 0,
      loader: false,
      filtro: {
        fechaInicio: new Date(),
        fechaFin: null
      },
      hoy: new Date(),
      diasMaximoMes: null,
      fieldsExcel: {
        "Referencia Multiva": "idReferencia",
        "id Ticket": "idTicket",
        "Fecha Compra":"fechaCompra",
        "Monto Pagado ($)": "montoPagado",
        "Monto menos Comisiones ($)": "montoMenosComisiones",
        "Monto menos iva ($)": "montoMenosIVA",
        "Comision (%)":"comision",
        "Vendedor": "nombreVendedor",
        "Plan":"plan",
        "Titular tarjeta":"titularTarjeta",
        "Id paciente":"idPaciente",
        "Nombre paciente":"nombrePaciente",
        "Tipo asegurado":"tipoAsegurado",
        "Tipo Tarjeta":"tipoTarjeta",
        "Correo":"correo",
        "Msi":"msi",
        "Renovacion":"renovacion",
        "Acepto terminos":"aceptoTermino"
      },
      idsReferenciaMultiva:[]
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {
    this.fields = [
      {key: "idReferencia", label: "Referencia Multiva", sortable: true},
      {key: "idTicket", label: "id Ticket", sortable: true},
      {key: "fechaCompra", label: "Fecha Compra", sortable: true},
      {key: "fechaRenovacion", label: "Fecha Renovación", sortable: true},
      {key: "montoPagado", label: "Monto Pagado ($)", sortable: true},
      {key: "montoMenosComisiones", label: "Monto menos Comisiones ($)", sortable: true},
      {key: "montoMenosIVA", label: "Monto menos iva ($)", sortable: true},
      {key: "comision", label: "Comision (%)", sortable: true},
      {key: "titularTarjeta", label: "Titular tarjeta", sortable: true},
      {key: "correo", label: "Correo", sortable: true},
      {key: "telefono", label: "Telefono", sortable: true}
    ];
  },
  methods:{
    obtenerDatos() {
      let fechaActual = this.$moment(this.filtro.fechaInicio);
      let fechaF = this.$moment(this.filtro.fechaFin);
      let fechaInicial = fechaActual.format("YYYY-MM-DD[T]HH:mm:ssZ");
      let fechaFinal = fechaF.format("YYYY-MM-DD[T]HH:mm:ssZ");
      this.loader = true;
      this.datosTabla = [];
      const filtro = {
        "fechaInicio": fechaInicial,
        "fechaFin": fechaFinal,
        "horas": this.$horas()
      };
      this.$http
          .post(this.$api + 'reportes/renovacionAutomaticaPortalSFTP', filtro)
          .then(respuesta => {
            if (respuesta.data.data) {
              if (respuesta.data.data !== undefined) {
                this.datosTabla = respuesta.data.data;
                this.armarJsonDescargarArchivo();
              }
            }
          }).finally(() => {
        this.loader = false;
        this.paginaActual = 0;
      })
    },
    fechaMaxima(event){
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.filtro.fechaInicio = new Date(event);
      this.filtro.fechaFin = null;

    },
    armarJsonDescargarArchivo(){
      this.datos = [];
      this.datosTabla.forEach(d=>{
        this.idsReferenciaMultiva.push(d.idReferencia);
        this.datos.push({
          "referencia": d.idReferencia,
          "numeroTrajeta": d.token,
          "importe": d.montoPagado,
          "correoElectronico": d.correo,
          "contrato": d.idReferencia
        });
      })
    }
  }
}
</script>
